export default "__VITE_ASSET__1Pb_FSey__"